import { SET_WORKERS } from "./types";

const state = {
  workers: [],
};

const mutations = {
  [SET_WORKERS](state, workers) {
    state.workers = workers;
  },
};

import * as getters from "./getters";
import * as actions from "./actions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
